import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { CSP_DIRECTIVES } from '~/constants';
import { createCspString } from './CSPHelmetUtils';

export const CSPHelmet: FC = () => {
  const cspString = createCspString(CSP_DIRECTIVES);

  return (
    <Helmet>
      <meta httpEquiv="Content-Security-Policy" content={cspString} />
    </Helmet>
  );
};
